import { ROW_WIDTHS } from '../types';
import { rowWidth } from './adjacency';

export interface LayoutConfig {
  viewportWidth: number;
  viewportHeight: number;
  pyramidTop: number;
  pyramidHeight: number;
  bottomFillRatio?: number;
  gapRatio?: number;
  verticalGapRatio?: number;
  cardAspect?: number;
}

export interface CardLayout {
  row: number;
  col: number;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface PyramidLayout {
  cardWidth: number;
  cardHeight: number;
  gap: number;
  verticalGap: number;
  cards: CardLayout[];
}

export function computePyramidLayout(cfg: LayoutConfig): PyramidLayout {
  const bottomFill = cfg.bottomFillRatio ?? 0.95;
  const gapRatio = cfg.gapRatio ?? 0.04;
  const cardAspect = cfg.cardAspect ?? 1.4;
  const verticalGapRatio = cfg.verticalGapRatio ?? 0.06;

  const bottomCount = ROW_WIDTHS[0]!;
  const bottomRowW = cfg.viewportWidth * bottomFill;
  const cardWidth = bottomRowW / (bottomCount + (bottomCount - 1) * gapRatio);
  const gap = cardWidth * gapRatio;
  const cardHeight = cardWidth * cardAspect;
  const verticalGap = cardHeight * verticalGapRatio;

  const totalRows = ROW_WIDTHS.length;
  const totalRowsHeight = totalRows * cardHeight + (totalRows - 1) * verticalGap;
  const fitScale = Math.min(1, cfg.pyramidHeight / totalRowsHeight);
  const w = cardWidth * fitScale;
  const h = cardHeight * fitScale;
  const g = gap * fitScale;
  const vg = verticalGap * fitScale;

  const cards: CardLayout[] = [];
  for (let r = 0; r < totalRows; r++) {
    const count = rowWidth(r);
    const rowVisualW = count * w + (count - 1) * g;
    const xStart = (cfg.viewportWidth - rowVisualW) / 2;
    const rowFromTop = totalRows - 1 - r;
    const y = cfg.pyramidTop + rowFromTop * (h + vg);
    for (let c = 0; c < count; c++) {
      cards.push({
        row: r,
        col: c,
        x: xStart + c * (w + g),
        y,
        width: w,
        height: h,
      });
    }
  }

  return {
    cardWidth: w,
    cardHeight: h,
    gap: g,
    verticalGap: vg,
    cards,
  };
}
